

import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { findOrdersEvent} from '../../../_events/orders/find_order.event';
import {displayPDFOrderEvent} from '../../../_events/orders/order_box.event';
import { message } from 'antd';
import PrimaryProgress from '../../../containers/progress/primary_progress';
import Chip from '@mui/material/Chip';
import Modal from '@mui/material/Modal';
import GeneralHistoryBoxList from './general_history_list';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  borderRadius: '20px',
  boxShadow: 24,
  p: 4,
};


const GeneralHistoryBox = () => {

  const in_process = 'GEN_HIS';
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openPDF, setOpenPDF] = React.useState(false);
  const [pdf, setPDF] = React.useState(null);

  const loadOrders = () => {
    setLoading(true);
    findOrdersEvent('GEN_HIS')
      .then(data => {
        let orders_list = [];
        data.list.forEach(obj => {
          if (obj.uuid != null && obj.id) {
            orders_list.push(obj);
          }
        });
        setOrders(orders_list);
        setLoading(false)
      })
      .catch(err => {
        message.error(err.message);
      });
  }

  const handleClosePDF = () => {
    setOpenPDF(false);
  };

  const displayPDF = (order) => {
    if (!order) message.error('No hay orden');
    else {
      let o = Object.assign({}, order);
      displayPDFOrderEvent(o)
        .then(data => {
          setPDF(data.data.toAproveJSON);
          setOpenPDF(true);
        })
        .catch(err => {
          message.error(err.message);
        });
    }
  }

  useEffect(() => {
    loadOrders();
  }, []);

  return (
    <Grid container spacing={1} >
      <Grid item xs={12} md={12}>
        <Typography variant="h6" component="h6">
          Historico general
        </Typography>
        <hr />
        {
          loading ? (
            <PrimaryProgress />
          ) : (
            <Grid container spacing={1}>
              <Grid item xs={6} md={6}>
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                  <Chip label={`Total: ${orders.length}`} color="primary" variant="outlined" />
                  <Chip label={`Entregas INMEDIATAS: ${orders.filter(o => o.date_delivery === null).length}`} color="error" variant="outlined" />
                  <Chip label={`Seleccionadas: ${orders.filter(o => o.checked === 1).length}`} color="success" variant="outlined" />
                </div>
              </Grid>
          
              <Grid item xs={12} md={12}>
                <GeneralHistoryBoxList
                  data={orders}
                  displayPDF={(o) => displayPDF(o)}
                />
              </Grid>
            </Grid>
          )
        }
      </Grid>
      <>

        <Modal
          open={openPDF}
          onClose={handleClosePDF}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Grid container spacing={1}>
              {
                !pdf ? <>Cargando...</> :
                  <Grid item xs={12} md={12}>
                    <object width="100%" height="600px"
                      data={`data:application/pdf;base64,${pdf}`}
                      type="application/pdf" className="internal"
                    >
                      <embed
                        src={`data:application/pdf;base64,${pdf}`}
                        type="application/pdf"
                      />
                    </object>
                  </Grid>
              }
            </Grid>
          </Box>
        </Modal>
      </>
    </Grid>
  );
}

export default GeneralHistoryBox;
